// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","681":"component---cache-caches-gatsby-plugin-offline-app-shell-js"}[chunkId] + "-" + {"245":"5d0f8b2181d932a34dfb","453":"af4f72aba20007697f3f","681":"4366aedf8abd703a1845"}[chunkId] + ".js";
};